import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Minimize02 = function Minimize02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2.9999 8h.2C4.88 8 5.72 8 6.3619 7.673a3 3 0 0 0 1.311-1.311c.327-.6418.327-1.4818.327-3.162V3m-5 13h.2c1.6801 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311c.327.6418.327 1.4818.327 3.162v.2m8-18v.2c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C18.2796 8 19.1197 8 20.7999 8h.2m-5 13v-.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C18.2796 16 19.1197 16 20.7999 16h.2"
    })
  }));
};
export default Minimize02;